module.exports = __webpack_public_path__ + "static/media/03-1.e1bb43e7.webp";